
export enum IoCodeEnum {
    ComponentValue = "ComponentValue",
    ComponentScheduleNextDate = "ComponentScheduleNextDate",
    ComponentComplete = "ComponentComplete",
    ComponentSettings = "ComponentSettings",
    ComponentTriggerEffects = "ComponentTriggerEffects",
    LabComplete = "LabComplete",
    DeletedLab = "DeletedLab",
    DeletedGadget = "DeletedGadget",
    DeletedComponent = "DeletedComponent",
    LabSettings = "LabSettings",
    GadgetComplete = "GadgetComplete",
    GadgetSettings = "GadgetSettings",
    LabUsers = "LabUsers",
    GadgetUsers = "GadgetUsers",
    GadgetUsersUpdated = "GadgetUsersUpdated",
    CreatedGadgetUsersForAllLabUsers = "CreatedGadgetUsersForAllLabUsers",
    LabUserCreated = "LabUserCreated",
    LabUsersUpdated = "LabUsersUpdated",
    LabUsersDeleted = "LabUsersDeleted",
    UpdatedLabController = "UpdatedLabController",
    DeletedLabController = "DeletedLabController",
    UserNotification = "userNotification",
    LabUserRequestDeleted = "LabUserRequestDeleted",
    DevicePresenceUpdated = "DevicePresenceUpdated",
    TestIO = "TestIO"
}
